import axios from "axios";

const state = {
  report_detail_transaksi: [],
  totalTransaction: {
    subtotal: 0,
    commission: 0,
    itemsSubtotal: 0,
    itemsCommission: 0,
  },
  totalAllTransaction: {
    subtotal: 0,
    commission: 0,
    itemsSubtotal: 0,
    itemsCommission: 0,
  },
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null,
  },
};

const actions = {
  async fetchReportDetailTransaksi({ commit }, params) {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/reports/detail-transaksi`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: params,
        }
      );
      const data = await response.data.data;
      console.log("data: ", data);

      commit("setReportDetailTransaksi", data);
      commit("setPagination", data.pagination);
    } catch (error) {
      if (error.response && error.response.status == 404) {
        commit("setReportDetailTransaksi", []); // No data found
      } else {
        console.error("Failed to fetch commissions:", error);
      }
    }
  },
};

const mutations = {
  setReportDetailTransaksi(state, report_detail_transaksi) {
    // Transform the new API response structure to match the expected format
    const transformedData = report_detail_transaksi.data.map((item) => ({
      transaction_code: item.pos_transaction.transaction_code,
      updatedAt: item.pos_transaction.updatedAt,
      users: item.user || item.users, // Handle both field names
      subtotal: item.pos_transaction.service_items.subtotal,
      commission: parseInt(item.commission),
      outlet_id: item.pos_transaction.outlet_id,
      items: [
        {
          product_name: item.pos_transaction.service_items.product_detail.name,
        },
      ],
    }));

    state.report_detail_transaksi = transformedData;
    state.totalTransaction = report_detail_transaksi.totalTransaction;
    state.totalAllTransaction = report_detail_transaksi.totalAllTransaction;
  },

  setPagination(state, pagination) {
    state.pagination.page = pagination.page || 1;
    state.pagination.perPage = pagination.perPage || 10;
    state.pagination.totalItems = pagination.totalItems || 0;

    state.pagination.previousPageLink = pagination.previousPageLink
      ? pagination.previousPageLink.replace(/\/api\/v1\/reports\?/, "")
      : null;
    state.pagination.nextPageLink = pagination.nextPageLink
      ? pagination.nextPageLink.replace(/\/api\/v1\/reports\?/, "")
      : null;
  },
};

const getters = {
  allDetailTransaksi: (state) => state.report_detail_transaksi,
  totalTransaction: (state) => state.totalTransaction,
  totalAllTransaction: (state) => state.totalAllTransaction,
  pagination: (state) => state.pagination,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
